import React, { useState } from 'react';
import { BasketIcon } from '../BasketIcon';

export const BasketHeader = ({ name, description }) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div 
      className="flex justify-between items-start mb-4 relative group"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div className="flex items-start space-x-2 w-full">
        <BasketIcon className="flex-shrink-0 w-6 h-6 sm:w-5 sm:h-5 mt-1" />
        <h2 className="text-xl sm:text-lg font-medium text-black break-words min-w-0 flex-grow">
          {name}
        </h2>
      </div>
      {isHovered && description && (
        <div className="absolute z-20 bg-neutral-100 text-neutral-900 px-3 py-2 rounded-xl shadow-lg max-w-xs text-xs italic font-light tracking-wide leading-relaxed opacity-90 transition-opacity duration-300 bottom-full left-0 mb-2 border-2 border-neutral-900">
          {description}
        </div>
      )}
    </div>
  );
};
